import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CompanyActions } from './company.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { CompanyService } from '@core/services/company.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class CompanyEffects {
  private actions$ = inject(Actions);
  private companyService = inject(CompanyService);
  private translateService = inject(TranslateService);
  getCompanies$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyActions.loadCompanies),
      mergeMap((data) =>
        this.companyService.getCompanies(data).pipe(
          map((companies) =>
            companies.success
              ? CompanyActions.loadCompaniesSuccess(companies)
              : CompanyActions.loadCompaniesSuccess(companies)
          ),
          catchError((error) =>
            of(
              CompanyActions.loadCompaniesFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  addCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyActions.addEditCompany),
      mergeMap((data) =>
        this.companyService.addCompany(data).pipe(
          map((company) => {
            if (company.success) {
              return data.id
                ? CompanyActions.updateCompanySuccess(company)
                : CompanyActions.addCompanySuccess(company);
            } else return CompanyActions.addCompanyFailure(company);
          }),
          catchError((error) =>
            of(
              CompanyActions.addCompanyFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  deleteCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyActions.deleteCompany),
      mergeMap((data) =>
        this.companyService.deleteCompany(data.id).pipe(
          map((response) =>
            response.success
              ? CompanyActions.deleteCompanySuccess({
                  ...response,
                  id: data.id,
                })
              : CompanyActions.deleteCompanyFailure(response)
          ),
          catchError((error) =>
            of(
              CompanyActions.deleteCompanyFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
